<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
    align-content-start>
    <v-layout
      justify-center
      wrap>
      <v-flex >
        <v-layout>
          <v-flex
            xs12
            md5
            xl5
            class="masterDropdown">

            <router-link
              :to="'/admin/account-inventory/master-payer'"
              tag="div">
              <v-btn>
              <v-icon
              color="primary"
              class="mr-2">arrow_back</v-icon> Go back to Masterpayer List
            </v-btn>
            </router-link>
          </v-flex>
        </v-layout>
        <formAdminAccountsDatatable
          :title="`Master Payer: ${this.$route.params.id}`"
          :type="'byMasterPayer'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data: () => ({

  }),
  computed: {

  },
  methods: {

  },
  mounted() {
    console.log('getting masterpayer account list')
    this.$store.commit('admin/accountInventory/removeSearchValue')
    this.$store.commit('admin/accountInventory/clearAccounts')
    let mpId = this.$route.params.id
    this.$store.commit('admin/accountInventory/setAccountFilters', {MP_ID: mpId, Acct_Status: [] })
  },
}
</script>
<style lang="scss">

</style>
